import { Box, PropertyCard } from '@zillow/constellation-10';

import propertyUtils from '../../../../utils/propertyUtils';

import BackgroundImage from '../../../../assets/onboarding_background.png';
import { backgroundStyles } from '../styles';

type Props = {
  address?: string;
  unit?: string;
};

const PropertyCardPreview = ({ address = '', unit = '' }: Props) => {
  const [street = '', city = '', stateAndZip = ''] = address.split(',');
  const [state = '', zip = ''] = stateAndZip.trim().split(' ');
  const { formattedCityStateZip, formattedStreet } = propertyUtils.formatAddress({
    street: street.trim(),
    unit: unit.trim(),
    city: city.trim(),
    state: state.trim(),
    zip: zip.trim(),
  });

  return (
    <Box css={{ ...backgroundStyles, position: 'relative' }}>
      <img
        // @ts-expect-error - In Next.js, the image will have a src property
        src={typeof BackgroundImage === 'string' ? BackgroundImage : BackgroundImage.src}
        alt="blue background"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />
      <Box css={{ maxWidth: '433px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <PropertyCard
          badge={<PropertyCard.Badge>New property</PropertyCard.Badge>}
          data={{
            dataArea1: <Box css={{ marginTop: '600', marginLeft: '200' }}>{formattedStreet}</Box>,
            dataArea2: <Box css={{ marginBottom: '600', marginLeft: '200' }}>{formattedCityStateZip}</Box>,
          }}
          photoBody={
            <PropertyCard.Photo alt="placeholder property image" fallbackImg={<PropertyCard.PhotoFallback />} />
          }
          saveButton={<PropertyCard.SaveButton />}
        />
      </Box>
    </Box>
  );
};

export default PropertyCardPreview;
